import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AnalyticsFilters, AnalyticsTab, ReviewFilters } from '../../types';

interface FiltersState {
  reviewFilters: ReviewFilters;
  analyticsFilters: {
    [AnalyticsTab.ACTIVITY]: AnalyticsFilters;
    [AnalyticsTab.PROGRESS_REPORT]: AnalyticsFilters;
    [AnalyticsTab.TEAM_PERFORMANCE]: AnalyticsFilters;
  };
}

/** Defines the initial state for filters related data. */
const INITIAL_FILTERS_STATE: FiltersState = {
  reviewFilters: {},
  analyticsFilters: {
    [AnalyticsTab.ACTIVITY]: {},
    [AnalyticsTab.PROGRESS_REPORT]: {},
    [AnalyticsTab.TEAM_PERFORMANCE]: {},
  },
};

/** filtersSlice is a Redux slice that manages filters state within the application. */
const filtersSlice = createSlice({
  name: 'filters',
  initialState: INITIAL_FILTERS_STATE,
  reducers: {
    resetAllFilters: () => INITIAL_FILTERS_STATE,
    setReviewFilters: (state, action: PayloadAction<ReviewFilters>) => {
      state.reviewFilters = action.payload;
    },
    setAnalyticsFilters: (state, action: PayloadAction<AnalyticsFilters & { tab: AnalyticsTab }>) => {
      const { tab, ...filters } = action.payload;
      state.analyticsFilters[tab] = filters;
    },
    updateReviewFilters: (state, action: PayloadAction<Partial<ReviewFilters>>) => {
      state.reviewFilters = { ...state.reviewFilters, ...action.payload };
    },
    updateAnalyticsFilters: (state, action: PayloadAction<Partial<AnalyticsFilters> & { tab: AnalyticsTab }>) => {
      const { tab, ...rest } = action.payload;
      state.analyticsFilters[tab] = {
        ...state.analyticsFilters[tab],
        ...rest,
      };
    },
  },
});

export const { resetAllFilters, setReviewFilters, setAnalyticsFilters, updateReviewFilters, updateAnalyticsFilters } =
  filtersSlice.actions;

export default filtersSlice.reducer;
